export interface TabSessionSyncState {
  sessionId: string;
  content: string;
}

/**
 * Tracks the exact editor content revision last accepted by each Engine
 * session. A tab/session ownership change invalidates the previous match.
 */
export class TabSessionSyncTracker {
  private readonly states = new Map<string, TabSessionSyncState>();

  mark(tabId: string, sessionId: string, content: string): void {
    this.states.set(tabId, { sessionId, content });
  }

  isSynced(tabId: string, sessionId: string, content: string): boolean {
    const state = this.states.get(tabId);
    return state?.sessionId === sessionId && state.content === content;
  }

  getContent(tabId: string, sessionId: string): string | undefined {
    const state = this.states.get(tabId);
    return state?.sessionId === sessionId ? state.content : undefined;
  }

  delete(tabId: string): void {
    this.states.delete(tabId);
  }

  clear(): void {
    this.states.clear();
  }
}
